import StarBorderIcon from '@mui/icons-material/StarBorderRounded';
import StarIcon from '@mui/icons-material/StarRounded';
import { ButtonBase } from '@mui/material';
import React from 'react';
import clsx from 'clsx';
import StyledBox from './styles';
import useBlackListLinks from '../../../../../../../Contexts/BlackListLinkContextProvider/useBlackLinstLinks';
import { NavigationLink } from '../../../../../../../Contexts/BlackListLinkContextProvider/BlackListLinkContext';

function FavoriteButton(props: { linkKey: NavigationLink }) {
  const { linkKey } = props;
  const { links, addLink, removeLink } = useBlackListLinks();

  const isFavorite = !links.includes(linkKey);
  return (
    <ButtonBase
      disableRipple
      onClick={() => { if (isFavorite) { addLink(linkKey); } else { removeLink(linkKey); } }}
    >
      {isFavorite ? <StarIcon /> : <StarBorderIcon />}
    </ButtonBase>
  );
}

export default function LinkWrapper(props: { linkKey: NavigationLink, children: React.ReactNode }) {
  const { links } = useBlackListLinks();
  const { linkKey, children } = props;
  return (
    <StyledBox className={clsx({ inactive: links.includes(linkKey) })}>
      <FavoriteButton linkKey={linkKey} />
      {children}
    </StyledBox>
  );
}
